import {Component, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {CardComponent} from "../../components/ui/card/card.component";
import {InputComponent} from "../../components/ui/input/input.component";
import {SelectComponent} from "../../components/ui/select/select.component";
import {Column, TableComponent} from "../../components/ui/table/table.component";
import {TranslateModule} from "@ngx-translate/core";
import {debounceTime, map, shareReplay, Subscription, switchMap} from "rxjs";
import {HttpParams} from "@angular/common/http";
import {Sort} from "../../models/sort";
import {SortHelper} from "../../utils/sort-helper";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {TagService} from "../../services/tag.service";

@Component({
  selector: 'app-tags-list',
  standalone: true,
  imports: [
    AsyncPipe,
    CardComponent,
    InputComponent,
    SelectComponent,
    TableComponent,
    TranslateModule,
    ReactiveFormsModule
  ],
  templateUrl: './tags-list.component.html',
  styleUrl: './tags-list.component.scss'
})
export class TagsListComponent implements OnInit, OnDestroy {
  public columns: Column[] = [
    { name: 'name', label: 'page.tags.list.name' },
    { name: 'color', label: 'page.tags.list.color', color: true },
    { name: 'icon', label: 'page.tags.list.icon' },
    { name: 'createdAt', label: 'page.tags.list.created', date: true },
  ];

  public data$ = this.route.queryParams.pipe(
    switchMap((queryParams) => {
      let requestParams = new HttpParams();

      if (queryParams['search']) {
        requestParams = requestParams.set('search', queryParams['search']);
      }

      let page = 0;
      if (queryParams['page']) {
        page = +queryParams['page'];
      }

      let sort: Sort | undefined = undefined;
      if (queryParams['sort']) {
        sort = SortHelper.convertStringToSort(queryParams['sort']);
      }

      return this.tagService.list(page, sort, requestParams);
    }),
    map(response => ({
      ...response,
      content: response.content.map(tag => ({
        ...tag,
        link: `/panel/tags/detail/${tag.id}`,
      })),
    })),
    shareReplay(1),
  );
  sortOptions = this.columns.map(column => ({ value: column.name, labelKey: column.label }));
  sortControl = new FormControl(this.route.snapshot.queryParams['sort'] ?? this.sortOptions[0].value);
  searchControl = new FormControl(this.route.snapshot.queryParams['search'] ?? '');
  subscriptions: Subscription[] = [];

  constructor(private route: ActivatedRoute, private tagService: TagService, private router: Router) {

  }

  changePage(page: number) {
    this.router.navigate([], {
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
  }

  ngOnInit() {
    this.subscriptions.push(
      this.sortControl.valueChanges.subscribe(value => {
        this.router.navigate([], {
          queryParams: { sort: value, page: 0 },
          queryParamsHandling: 'merge',
        });
      }),
      this.searchControl.valueChanges.pipe(debounceTime(400)).subscribe(value => {
        this.router.navigate([], {
          queryParams: { search: value, page: 0 },
          queryParamsHandling: 'merge',
        });
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
